import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import TitleAndClientSection from "./TitleAndClientSection";
import ButtonSection from "./ButtonSection";
import apiRequestHelper from "../../../../utils/apiRequestHelper";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import SchemaFieldArray from "./SchemaFieldArray";
import SeoImageUpload from "./SeoImageUpload";
// --- Types
interface BlogSEO {
  seoTitle: string;
  seoDescription: string;
  seoImageAlt: string;
  schemaJson: string[];
  image: File | null;
  imageUrl?: string;
}

// --- Validation
const BlogSEOSchema = Yup.object().shape({
  seoTitle: Yup.string().optional(),
  seoDescription: Yup.string(),
  seoImageAlt: Yup.string().max(150, "Alt text must be under 150 characters"),
  schemaJson: Yup.array().of(
    Yup.string().test("is-json", "Invalid JSON object", (value) => {
      if (!value) return false;
      try {
        JSON.parse(value);
        return true;
      } catch {
        return false;
      }
    }),
  ),
});
const CreateNewProjectForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState<BlogSEO>({
    seoTitle: "",
    seoDescription: "",
    seoImageAlt: "",
    schemaJson: [],
    image: null,
    imageUrl: "",
  });

  useEffect(() => {
    if (id) {
      apiRequestHelper
        .get(`/blogs/seo/${id}`)
        .then((res) => {
          const seo = res.data?.seo || {};
          setInitialValues({
            seoTitle: seo.seoTitle || "",
            seoDescription: seo.seoDescription || "",
            seoImageAlt: seo.seoImageAlt || "",
            schemaJson: Array.isArray(seo.schemaJson)
              ? seo.schemaJson.map((obj: any) => JSON.stringify(obj, null, 2))
              : [],
            image: null,
            imageUrl: seo.imageUrl || "", // backend source
          });
        })
        .catch(() => toast.error("Failed to load SEO data"));
    }
  }, [id]);

  const handleSubmit = async (values: BlogSEO) => {
    try {
      const parsedSchemas = values.schemaJson.map((str) => JSON.parse(str));

      const formData = new FormData();
      formData.append("blogId", String(id));
      formData.append("seoTitle", values.seoTitle);
      formData.append("seoDescription", values.seoDescription);
      formData.append("seoImageAlt", values.seoImageAlt);
      formData.append("schemaJson", JSON.stringify(parsedSchemas));

      if (values.image instanceof File) {
        formData.append("image", values.image); // ✅ backend key
      }

      await apiRequestHelper.post(`/blogs/seo`, formData, true);

      toast.success("SEO saved successfully!");
      navigate("/blogs/cards");
    } catch (err: any) {
      toast.error(
        err.response?.data?.messages?.[0]?.message || "Failed to save SEO.",
      );
    }
  };

  return (
    <Formik<BlogSEO>
      enableReinitialize
      initialValues={initialValues}
      validationSchema={BlogSEOSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <Form className="theme-form">
          <TitleAndClientSection />
          <SchemaFieldArray />
          <SeoImageUpload />
          <ButtonSection />
        </Form>
      )}
    </Formik>
  );
};

export default CreateNewProjectForm;
